export default __webpack_public_path__ + "bf29e2bbcb6afc84690739eaed24bda3.svg";